import produce from 'immer';

import { HowToStartModalAction } from './actions';
import * as constants from './constants';
import { HowToStartModalStore } from './typings';

const initialState: HowToStartModalStore = {
    isOpenedManually: false,
    isOpenedAutomatically: true,
};

export const howToStartModalReducer = (state: HowToStartModalStore = initialState, action: HowToStartModalAction) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case constants.OPEN_MODAL:
                draft.isOpenedManually = true;
                break;

            case constants.CLOSE_MODAL:
                draft.isOpenedManually = false;
                draft.isOpenedAutomatically = false;
                break;

            default:
                break;
        }
    });
};
